import { action, observable } from 'mobx';
import { ConfigStore } from '../../service-setup/ConfigStore';
import { IProduct } from '../interfaces/IRating';
import { PowerReviewsProduct } from '../domain/entities/PowerReviewsProduct';

export class ProductRepository {
    @observable public products: IProduct[] = [];
    @observable public productId: string = '';
    @observable public selectedSkuId: string = '';
    @observable public configStore: ConfigStore;
    @observable public paginationType: string = '';

    constructor(configStore: ConfigStore) {
        this.configStore = configStore;
    }

    @action
    public updateProductId = (productId: string) => {
        this.productId = productId;
    };

    @action
    public setPaginationType = (paginationType: string) => {
        this.paginationType = paginationType;
    };

    @action
    public setSelectedSkuId = (skuId: string) => {
        this.selectedSkuId = skuId;
    };

    @action
    public setProducts = (products: IProduct[]) => {
        const listOfProducts = [...this.products, ...products];

        this.products = listOfProducts.filter(
            (product, index, arr) =>
                arr.findIndex((i) => i.product_id === product.product_id) === index
        );
    };

    public getProductById = (productId: string) =>
        <IProduct>this.products.find((prod: IProduct) => prod.productId === productId);

    public getPowerReviewsProduct(products: IProduct[]) {
        const { ratingsReviewsConfig } = this.configStore.config;

        return PowerReviewsProduct.fromJson(
            products[0],
            ratingsReviewsConfig,
            this.paginationType,
            this.selectedSkuId
        );
    }
}
